import { render, staticRenderFns } from "./SessionsShow.vue?vue&type=template&id=b6669734&scoped=true"
import script from "./SessionsShow.vue?vue&type=script&lang=js"
export * from "./SessionsShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6669734",
  null
  
)

export default component.exports